import React, { useReducer } from "react";
import PropTypes from "prop-types";
import Context from "./context";
import Reducer from "./reducer";
import { SET_LOADING, SET_DOCS, SET_ERROR } from "./types";

const ResourcesState = props => {
  const initialState = {
    loading: true,
    error: null,
    docs: [],
    filters: {
      title: "",
      category: "",
      type: ""
    }
  };
  const init = initialState => ({ ...initialState });
  const [state, dispatch] = useReducer(Reducer, initialState, init);

  const getProgramResources = () => getDocs("resources/program-resources.json");
  const getAoResources = () => getDocs("ao-resources/ao-resources.json");
  const getPublications = () => getDocs("publications/publications.json");

  const getDocs = async file => {
    setLoading();
    try {
      const res = await fetch(`${process.env.GATSBY_STATIC_BASE_URL}/${file}`, {
        cache: "no-cache"
      });
      const json = await res.json();
      dispatch({
        type: SET_DOCS,
        payload: json
      });
    } catch (err) {
      console.error("Error getting resources: ", err);
      dispatch({
        type: SET_ERROR,
        payload:
          "Sorry, there was an issue loading the list of resources. Please try again later."
      });
    }
  };

  const setLoading = async () => dispatch({ type: SET_LOADING });

  return (
    <Context.Provider
      value={{
        loading: state.loading,
        error: state.error,
        types: state.types,
        categories: state.categories,
        laos: state.laos,
        docs: state.docs,
        getProgramResources,
        getAoResources,
        getPublications,
        ...props.value
      }}
    >
      {props.children}
    </Context.Provider>
  );
};

ResourcesState.propTypes = {
  children: PropTypes.node,
  value: PropTypes.object
};

export default ResourcesState;
